import { render, staticRenderFns } from "./NoticeBar.vue?vue&type=template&id=e0a23b18&scoped=true"
import script from "./NoticeBar.vue?vue&type=script&lang=js"
export * from "./NoticeBar.vue?vue&type=script&lang=js"
import style0 from "./NoticeBar.vue?vue&type=style&index=0&id=e0a23b18&prod&lang=scss&scoped=true"
import style1 from "./NoticeBar.vue?vue&type=style&index=1&id=e0a23b18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a23b18",
  null
  
)

export default component.exports